import { createIcon } from '@chakra-ui/react';

export const History = createIcon({
  displayName: 'History',
  viewBox: '0 0 24 24',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 9.3V14.7C11 15 11.19 15.09 11.42 14.92L14.82 12.33C14.926 12.259 14.994 12.14 14.994 12.005C14.994 11.87 14.925 11.751 14.821 11.681L11.42 9.09C11.19 8.91 11 9 11 9.3ZM12.75 3C7.732 3.004 3.649 7.002 3.51 11.987L2 12L4 14L6 12H4.51C4.643 7.542 8.289 3.979 12.767 3.979C17.329 3.979 21.027 7.677 21.027 12.239C21.027 16.801 17.329 20.499 12.767 20.499C10.413 20.499 8.288 19.514 6.784 17.934L6.781 17.931C6.69 17.84 6.565 17.784 6.426 17.784C6.149 17.784 5.924 18.009 5.924 18.286C5.924 18.425 5.98 18.55 6.071 18.641C7.758 20.405 10.131 21.501 12.759 21.501C17.868 21.501 22.009 17.36 22.009 12.251C22.009 7.142 17.868 3.001 12.759 3.001C12.756 3.001 12.753 3.001 12.75 3.001V3Z"
      fill="currentColor"
    />
  ),
});
